import React, { useEffect, useState } from "react";
import { UploadFile, StartBrowserOpenUrl } from "../logic/BosFileTransfer";
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";
import WidgetImage from "../../components/WidgetImage";
import ContentLoading from "../../components/ContentLoading";
import * as Constants from "../logic/Constants";
import FileDragAndDrop from "../../components/FileDragAndDrop";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./PictureWidget.module.scss";

export function PictureWidget(props) {
  const { ui, config, data, writeBack, dataSegment } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  let fileInputSelector;

  let widgetId = ui.id;
  let disabled = ui.readonly || (data && data.readonly);

  let content = data && data.content ? JSON.parse(data.content) : "";
  let displayContent = content && content.FileName ? content.FileName : "";
  let valueContent = content && content.FileId ? content.FileId : "";
  let enabledActions = content ? content.EnabledActionIds : [];
  let imageMode = config ? config.ImageMode : null;
  let noBorder = config ? config.NoBorder : false;
  let useCircleImage = config ? config.UseCircleImage : false;

  useEffect(() => {
    if (valueContent)
      setPreviewImage(BosFilesServices.getProtectedWebResourceUrl(dataSegment.authToken, valueContent));
    else
      setPreviewImage();
  }, [data]);

  const handleDocumentClick = (event) => {
    event.preventDefault();

    //alert("X: " + (event.nativeEvent.offsetX) + " Y: " + (event.nativeEvent.offsetY));

    if (disabled) return;
    let fileId = valueContent;
    downloadDocument(fileId);
  };

  const handleAttachNewDocumentClick = () => {
    if (disabled) return;
    selectNewDocument();
  };

  const selectNewDocument = () => {
    fileInputSelector.click();
  };

  const handleFileSelected = (event) => {
    event.preventDefault();
    uploadDocument(event.target.files);
  };

  const uploadDocument = (files) => {
    let selectedFile = files ? (files.length > 0 ? files[0] : null) : null;
    if (selectedFile) {
      console.log("Uploading selected file", selectedFile);
      setIsLoading(true);
      UploadFile(selectedFile, dataSegment.authToken, dataSegment.id)
        .then(fileId => {
          console.log("Upload result: ", fileId);
          let value = JSON.stringify({ FileId: fileId });
          writeBack(value, true);
          setIsLoading(false);
        })
        .catch(error => {
          console.error("Upload result: ", error);
          setIsLoading(false);
        });
    }
    else {
      console.log("No file selected -> nothing to upload");
    }
  };

  const downloadDocument = (fileId) => {
    console.log("Downloading file", fileId);
    StartBrowserOpenUrl(previewImage);
  };

  const isActionAllowed = actionId => {
    return enabledActions.includes(actionId);
  };

  const handleFileDrop = (files) => {
    uploadDocument(files);
  };

  const circleStyle = () => ({
    borderRadius: "50%",
    boxShadow: "3px 3px 3px #00000099",
    width: "calc(" + ui.controlWidth + "em - 6px)",          //respects box shadow values: offset x + blur
    height: "calc(" + ui.controlHeight + "em - 6px)"         //respects box shadow values: offset y + blur
  });

  const normalStyle= () => ({
    width: "100%",
    height: "100%"
  });

  return (
    <div className={classes.picWrapper} id={widgetId}>
      <div className={classes.floating}>
        {disabled || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)
          ? null
          : (
            <Button
              className={classes.button}
              icon="file"
              stylingMode="text"
              onClick={() => handleAttachNewDocumentClick()}
            />
          )
        }
      </div>
      <FileDragAndDrop disabled={disabled || !isActionAllowed(Constants.DOCUMENT_WIDGET_UPLOAD_ACTION)} handleDrop={handleFileDrop} style={{ height: "100%", width: "100%" }}>
        <div className={cn(classes.imageWrapper, noBorder ? "" : "dx-texteditor", "dx-editor-outlined")} style={useCircleImage ? circleStyle() : normalStyle()}>
          {isLoading
            ? <ContentLoading />
            : previewImage
              ? <WidgetImage mode={imageMode} src={previewImage} disabled={!isActionAllowed(Constants.DOCUMENT_WIDGET_DOWNLOAD_ACTION)} onClick={handleDocumentClick} />
              : <pre>{displayContent}</pre>
          }
        </div>
      </FileDragAndDrop>
      {/* INVISIBLE FILE UPLOAD INPUT */}
      <input type="file" multiple={false} accept="*/*" ref={el => fileInputSelector = el} onChange={(e) => handleFileSelected(e)} style={{ display: "none" }} />
    </div>
  );
}
